import Api from 'src/api/Base'

class PatchProductHfss extends Api {
  requestUrl = `/api/product/hfss-status`

  method = 'PATCH'
}

export default PatchProductHfss
